module.exports = __webpack_public_path__ + "static/media/death_mode_desktop.59cf57b5.png";